import axiosInstance from '../../../../config/axiosInstance';
import { AssetCategoryValidation } from "../../views/AssetCategory/Validation/AssetCategoryValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = AssetCategoryValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateAssetCategory`, formData);
      setFormData({
        AssetCategory: '',
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };